export default __webpack_public_path__ + "static/media/sucess.5d37a219.png";